import PaiementFormController from './paiement.form.controller';

export default {
    template: require('./paiement.form.html'),
    controller: PaiementFormController
};
